<template>
    <div style="color: black;font-size: 20px;font-weight: bolder">
        <div v-if="!waiting">
            <div v-if="tournoi.options.championnat.type=='gg'">
                <div v-if="nbEquipeSup>0">
                    Vous avez {{nbEquipes}} équipes qualifées pour la suite du tournoi ! <br/>
                    Il y a trop d'équipes pour faire {{ciblePhase(goodNbEquipes)}} ({{goodNbEquipes}} équipes)<br/>
                    <b>Il faut donc en éliminer {{nbEquipeSup}}</b><br/>
                    <hr/>
                    Vous pouvez faire un cadrage <span class="icon"><i class="fas fa-question-circle"/></span> tout de suite avec {{nbEquipeSup*2}} équipes.
                    <div>
                        Les {{nbEquipeSup*2}} équipes seront tirées au sort parmis les {{nbEquipes}} équipes 
                    </div>
                    <br/>
                    Mais vous pouvez également faire une partie éliminatoire <span class="icon"><i class="fas fa-question-circle"/></span> et faire le cadrage plus tard.
                    <hr/>
                    <b>Faites votre choix :</b>
                    <br/><br/>
                    <div style="text-align:center">
                        <div style="float:left; padding-left: 20px">
                            <s-button icon="object-group" label="Cadrage ?" theme="is-primary" @onclick="cadrage" /> 
                        </div>
                        <div style="float:right; padding-right: 20px">
                            <s-button icon="bolt" label="Eliminatoire ?" theme="is-primary" @onclick="eliminiatoire" />
                        </div>
                    </div>
                    <br/><br/><br/>
                    <div class="notification is-info">
                        A ce stade, nous vous préconisons de faire une partie éliminatoire avant de faire un cadrage.
                        Attention, vous ne pourrez plus revenir sur les scores des poules
                    </div>
                </div>
                <div v-if="nbEquipeSup==0">
                Vous êtes sur le point de faire le tirage pour  {{ciblePhase(goodNbEquipes)}}<br/>
                Souhaitez vous continuer ? <br/>
                <i>(vous ne pourrez plus revenir sur les scores des poules)</i><br/>
                <div style="float:left; padding-left: 20px;margin-top: 20px;">
                    <s-button icon="undo" label="Annuler" theme="is-warning" @onclick="$emit('cancel')" />
                </div>
                <div style="float:right;margin-top: 20px; ">
                        <s-button icon="play" label="Continuer" theme="is-success" @onclick="eliminiatoire" />
                </div>
                </div>
            </div>
            <div v-if="tournoi.options.championnat.type=='classique'" class="champClassique">
                <div v-if="screenQualified==0">
                    <div style="text-align:right">
                        <s-button label="Continuer" @onclick="next()" icon="" theme="is-success"/>
                    </div>
                Les qualifiés sont :
                <div style="vertical-align: top">
                    <div v-for="(itemPoule, indexPoule) in poule" class="poule"  >
                        <table class="tablePoule">
                            <tr>
                                <th colspan="6">Poule {{indexPoule+1}}</th>
                            </tr>
                            <tr class="g_desktopOn">
                                <th>Rang</th>
                                <th>Numero</th>
                                <th>Nom</th>
                                <th>Parties Gagnés</th>
                                <th>Goal Average</th>
                                <th>Qualifie</th>
                            </tr>
                            <tr class="g_mobileOn">
                                <th>Rang</th>
                                <th>N°</th>
                                <th>Nom</th>
                                <th>PG</th>
                                <th>GA</th>
                                <th></th>
                            </tr>
                            <tr v-for="dataJoueur in itemPoule" :class="WhatIsClass(dataJoueur)">
                                <td>{{dataJoueur.rang}}</td>
                                <td>{{parseInt(dataJoueur.numero)+1}}</td>
                                <td>{{tournoi.joueurs[dataJoueur.numero].pseudo}}</td>
                                <td>{{dataJoueur.win}}</td>
                                <td>{{dataJoueur.goalAverage}}</td>
                                <td  class="g_desktopOn" v-if="dataJoueur.balotage">en balotage</td>
                                <td class="g_mobileOn" v-if="dataJoueur.balotage">B</td>
                                <td v-if="!dataJoueur.balotage" class="g_desktopOn">
                                        <span v-if="dataJoueur.qualifie && dataJoueur.complete">Repeche</span>
                                        <span v-if="dataJoueur.qualifie && !dataJoueur.complete">Qualifié</span>
                                        <span v-if="!dataJoueur.qualifie">non qualifié</span>
                                </td>
                                <td v-if="!dataJoueur.balotage" class="g_mobileOn">
                                        <span v-if="dataJoueur.qualifie && dataJoueur.complete">R</span>
                                        <span v-if="dataJoueur.qualifie && !dataJoueur.complete">Q</span>
                                        <span v-if="!dataJoueur.qualifie">N</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                </div>
                <div v-if="screenQualified==1">
                    <div>
                        <div style="display:inline-block;text-align:left;width: 50%">
                            <s-button @onclick="screenQualified=0" label="Revenir" icon="undo" theme="is-warning"/>
                        </div>
                        <div style="display:inline-block;text-align:right;width: 50%">
                            <s-button label="Continuer" @onclick="screenQualified=2" icon="" theme="is-success" :disabled="!continueEquipeCompleted || GoForAleatoire"/>
                        </div>
                    </div>
                    Des équipes sont en balotage...
                    <div><i> Elles ont le nmême nombre de parties gagnées avec le même goal average.</i></div>
                    <br/>
                    <span v-if="nbQualifieReel==1" class="alerteEquipe">1 seule équipe peut être repêchée pour la suite</span>
                    <span v-if="nbQualifieReel>1" class="alerteEquipe">Seules {{nbQualifieReel}} équipes peuvent êtes repêchées pour la suite</span><br/>
                    <br/>
                    <b>Vous avez 2 solutions :</b> <br/>
                    <div class="oneSolution">
                    &nbsp;&nbsp;Soit vous tirez au sort le ou les équipes  : 
                    <div class="buttonAleatoire" v-if="!GoForAleatoire">
                        <s-button label="Qualification aléatoire" @onclick="aleatoire()" icon="" theme="is-primary" />
                    </div> 
                        <div v-if="GoForAleatoire" class="tirageAleatoire">
                            <div class="loader" >
                                <span></span>
                            </div>
                            <div >Tirage aléatoire en cours</div>
                        </div>
                        </div>
                
                    <hr/>
                    <div class="twoSolution">
                    &nbsp;&nbsp;Soit vous les qualifiez vous même <br/>
                    <i>en les faisant rencontrer sur une seule mène par exemple</i> 
                <div style="vertical-align: top;text-align:center;width:100%">
                    
                
                        <table class="tablePoule">
                            <tr style="color:black" class="g_desktopOn">
                                <th width="5%">Rang</th>
                                <th width="5%">Numero</th>
                                <th width="50%">Nom</th>
                                <th width="40%"></th>
                                
                            </tr>
                            <tr v-for="dataJoueur in pouleComplete" v-if="dataJoueur.balotage" :class="dataJoueur.qualifie ? 'qualifie' : 'balotage'">
                                <td>{{dataJoueur.rang}}</td>
                                <td>{{parseInt(dataJoueur.numero)+1}}</td>
                                <td>{{tournoi.joueurs[dataJoueur.numero].pseudo}}</td>
                                <td>
                                    <s-button 
                                        :theme="dataJoueur.qualifie ? 'is-success is-small' : 'is-small is-warning'" 
                                        :label="dataJoueur.qualifie ? 'Qualifie' : 'Non qualifié'" @onclick="isQualified(dataJoueur)"
                                        :disabled="GoForAleatoire"
                                    />
                                </td>
                                
                            </tr>
                        </table>
                        <div>
                            <i style="font-size:12px">Cliquez sur le bouton qualifie sur la ligné de l'équipe gagnante</i> 
                        </div>
                    </div>
                    </div>
            
                </div>
                <div v-if="screenQualified==2">
                    <div>
                        <div style="display:inline-block;text-align:left;width: 50%">
                            <s-button @onclick="screenQualified=0" label="Revenir" icon="undo" theme="is-warning"/>
                        </div>
                        <div style="display:inline-block;text-align:right;width: 50%">
                            <s-button label="Continuer" @onclick="eliminatoireClassique()" icon="" theme="is-success" :disabled="!continueEquipeCompleted || GoForAleatoire"/>
                        </div>
                    </div>
                    Vous vous apprétez à lancer {{ciblePhase(goodNbEquipes)}}<br/>
                    Attention vous ne pourrez plus modifier les scores des poules<br/>
                    <i>Cliquez sur continuer</i>
                </div>
            </div>
        </div>
        <div v-if="waiting">
            Traitement en cours ...<br/>
            <br/>
            <i>Merci de patienter</i>
        </div>
    </div>
</template>
<style scoped>
    .tirageAleatoire {
        background-color: white;
        color: gray;
        padding: 10px;
    }
    .oneSolution {
        background-color: rgb(127, 201, 204);
        padding: 5px;
        margin: 10px;
        text-align: center;
        font-size: 18px;
        
    }
    .twoSolution {
        background-color: rgb(30, 183, 189);
        padding: 5px;
        margin: 10px;
        text-align: center;
        font-size: 18px;
    }
    .alerteEquipe {
        font-weight: bolder;
        font-size: 18px;
    }
    .champClassique {
        font-size: 14px;
        color: black;
    }
   
    .qualifie {
        background-color: greenyellow;
    }
     .repeche {
        background-color: rgb(217, 245, 176);
    }
    .nonQualifie {
        background-color: gray;
    }
    .balotage {
        background-color: orange;
    }
    .poule {
        display: inline-block;
        margin: 5px;
        border: thin solid black;
        width: 100%;
        padding: 2px;

    }
    .tablePoule {
        font-size: 14px;
        color: black;
        width: 100%;
    }
    .tablePoule tr th {
        border: thin solid black;
        text-align: center;
        padding: 2px;
    }
    .tablePoule tr td {
        border: thin solid black;
        text-align: center;
        padding: 2px;
    }

    .loader {

            margin: auto;
            border: 20px solid #EAF0F6;
            border-radius: 50%;
            border-top: 20px solid #FF7A59;
            width: 50px;
            height: 50px;
            animation: spinner 4s linear infinite;
    }


 


@keyframes spinner {


  0% { transform: rotate(0deg); }


  100% { transform: rotate(360deg); }


}



</style>
<script>
import Championnat from "@/firebase/championnat/tirage"
import Championnat_DB from "@/firebase/championnat"
import tournoi_fct from '@/firebase/tournoi'
import exportMembresVue from '../../club/exportMembres.vue'
export default {
    props:["tournoi", "club", "equipes", "indexPartie", "open"],
    data() {
        return  {
            nbEquipes: 0,
            goodNbEquipes: 0,
            nbEquipeSup: 0,
            poule: [],
            pouleComplete: [],
            screenQualified: 0,
            nbQualifieReel: 0,
            continueEquipeCompleted: false,
            GoForAleatoire : false,
            waiting: false
        }
    },
    watch: {
        open: function(val) {
           this.waiting = false;
           if (val) {
                if (this.tournoi.options.championnat.type=='gg')
                    this.initNbEquipes();
                else {
                    this.screenQualified = 0;
                    this.nbQualifieReel = 0;
                    this.pouleComplete = [];
                    this.continueEquipeCompleted = false;
                    this.initClassementByPoule();
                }
            }
        }
    },
    methods: {
            tirageAleatoire(go) {
                
                var nbQualified = 0;
                var max = this.pouleComplete.length;
               
                while (nbQualified != this.nbQualifieReel) {
                    var equipeQualifed = Math.floor(Math.random() * max);
                    if (this.pouleComplete[equipeQualifed].balotage) {
                        this.isQualified(this.pouleComplete[equipeQualifed], go);
                        nbQualified++;
                    }
                }
            },
            aleatoire(timeout, nbRoulette, go) {
                this.GoForAleatoire = true;
                var timeOutLocal = 0;
                if (typeof(nbRoulette)=="undefined")
                    nbRoulette = 0;
                    timeOutLocal = setTimeout(()=>{                    
                    if (typeof(timeout)=="undefined")
                        timeout = timeOutLocal;
                    this.tirageAleatoire(go);
                    if (nbRoulette<10) {
                        this.aleatoire(timeout, nbRoulette+1, true);
                    }
                    else {

                        this.nbEquipeQualifedCompleted();
                        if (!this.continueEquipeCompleted) 
                             this.aleatoire(timeout, nbRoulette+1, false);
                        else {
                            this.GoForAleatoire = false;
                            clearTimeout(timeout);  
                        }
                    }
                    
                }
                ,100)
            },
            nbEquipeQualifedCompleted() {
                    var nbEquipeQualifed = 0;
                    this.pouleComplete.forEach(equipe=>{
                        if (equipe.balotage && equipe.qualifie)
                            nbEquipeQualifed++;
                    })
                    
                    this.continueEquipeCompleted = nbEquipeQualifed == this.nbQualifieReel;
            },
            isQualified(dataJoueur, go) {
                dataJoueur.qualifie =  !dataJoueur.qualifie;
                this.nbEquipeQualifedCompleted();
            },
            next() {
                
                if (this.screenQualified==1)
                    this.screenQualified=2;
                else {
                    var nbQualifie = this.tournoi.options.championnat.nbQualifie;
                    var nbQualifieComplete = this.tournoi.options.championnat.nbResteQualifie;
                    nbQualifie = this.poule.length*nbQualifie + nbQualifieComplete;
                    var screenQualified = 2;
                    
                    var nbQualifieReel = 0;
                    this.poule.forEach(poule=>{
                        poule.forEach(itemPoule=>{
                        if (itemPoule.qualifie && !itemPoule.balotage)
                            nbQualifieReel++;
                        else
                            itemPoule.qualifie = false;
                        })
                    })
                    this.nbQualifieReel = nbQualifie - nbQualifieReel;
                    this.pouleComplete.forEach(dataJoueur=>{
                        if (dataJoueur.balotage == true) {
                            screenQualified = 1;
                        }
                    })
                    this.screenQualified = screenQualified;
                }
                
            },
            WhatIsClass(dataJoueur) {
                if (dataJoueur.balotage)
                    return "balotage";
                else if (dataJoueur.complete && dataJoueur.qualifie) 
                    return "repeche";
                else
                    return dataJoueur.qualifie ? 'qualifie' : 'nonQualifie'
            },
            async cadrage() {
                this.waiting = true;
                await Championnat_DB.object.cadrage(this.club, this.tournoi, this.nbEquipes, this.indexPartie+1);
                this.waiting = false;
                this.$emit("close");
            },
            async eliminatoireClassique() {
                this.waiting = true;
                await Championnat_DB.object.eliminatoireClassique(this.club, this.tournoi, this.poule, this.indexPartie);
                this.waiting = false;
                this.$emit("close");
                
            },
            async eliminiatoire() {
                this.waiting = true;
                await Championnat_DB.object.eliminatoire(this.club, this.tournoi, this.indexPartie);
                if (this.nbEquipeSup==0) {
                    this.tournoi.cadrage = true;
                    tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                        this.waiting = false;
                        this.$emit("close");
                    })
                }
                else {
                    this.waiting = false;
                    this.$emit("close");
                }
                    
                
            },
            nbEgauxPoules(poules, index, nb, win, ga) {
              
                if (index<poules.length) {
                  
                    var execo = poules[index].win == win && poules[index].goalAverage == ga;  
                    if (execo) {
                        nb++;
                        return this.nbEgauxPoules(poules, index+1, nb, win, ga);
                    }
                    else
                        return nb;
                }   
                else
                    return nb;
            },
            isPouleBalotage(poules, index, win, ga, type) {
                 if (index<poules.length) {
                        if (type=="balotage")
                            poules[index].balotage = true;
                        if (type=="qualified") {
                            poules[index].qualifie= true;
                            poules[index].complete= false;
                            poules[index].balotage= false;
                        }
                        if (type=="repechage") {
                            poules[index].qualifie= true;
                            poules[index].complete= true;
                            poules[index].balotage= false;
                        }
                        if (type=="disqualified") {
                            poules[index].qualifie= false;
                            poules[index].complete= false;
                            poules[index].balotage= false;
                        }
                        var execo = poules[index].win == win && poules[index].goalAverage == ga;  
                        if (execo) {
                            return this.isPouleBalotage(poules, index+1, win, ga, type);
                        }
                }
            },
            detectPouleBalotage(poules, index, nbRepechageCurrent, nbRepechageTotal, type) {
                // nbRepechage est le nombre à repêché
                
                if (index<poules.length) {
                    var indexEgaux = index;
                    var win = poules[indexEgaux].win;
                    var ga = poules[indexEgaux].goalAverage;
                 
                    var nbEgaux = this.nbEgauxPoules(poules, indexEgaux+1, 1, win, ga);
                    
                    if (nbRepechageCurrent<nbRepechageTotal) {
                    
                        // cela sous entend qu'on peut encore repêche des équipes
                        var nbCalculRepechageCurrent = nbRepechageCurrent + nbEgaux;
                        console.log(nbCalculRepechageCurrent);
                        if (nbCalculRepechageCurrent > nbRepechageTotal) {
                            // cela sous entend que le reste doit être en blotage
                        
                            this.isPouleBalotage(poules , indexEgaux, win, ga, "balotage");
                        }
                        else {
                           
                            this.isPouleBalotage(poules , indexEgaux, win, ga, type);
                        }
                        index += nbEgaux ;
                        index--;
                        
                        this.detectPouleBalotage(poules, index+1, nbCalculRepechageCurrent, nbRepechageTotal, type)
                    }
                    else {
                      
                        var indexEgaux = index;
                        this.isPouleBalotage(poules , indexEgaux, win, ga, "disqualified");
                    }
                }
            },
            async initClassementByPoule() {
                this.screenQualified = 0;
                var jsonQualifie = await Championnat_DB.object.whoIsQualified(this.club, this.tournoi);
            
                var poule = [];
                //Calculer le RANG
                for (var win in jsonQualifie) {
                    for (var joueur in jsonQualifie[win]) {
                        var joueurData = jsonQualifie[win][joueur];
                        if (joueurData.numero != 'null') {
                            var howWin = 0;
                            switch (win) {
                                case 'win2':
                                    howWin = 3;
                                    break;
                                case 'win1':
                                    howWin = 2;
                                    break;
                                case 'looser':
                                    howWin = 1;
                                    break;

                            }
                            
                            var jsonJoueur = {
                                numero: joueurData.numero,
                                goalAverage: joueurData.goalAverage,
                                win: howWin,
                                rang: null,
                                qualifie: false,
                                balotage : false,
                                rangComplete: null,
                                execo: false,
                                complete: false
                            }                        
                           
                            if (typeof(poule[joueurData.pool]) == "undefined")
                                poule[joueurData.pool] = [];
                            poule[joueurData.pool].push(jsonJoueur);
                        }
                    }
                }
                var nbQualifie = this.tournoi.options.championnat.nbQualifie;
                var nbQualifieComplete = this.tournoi.options.championnat.nbResteQualifie;
                poule.forEach((itemPoule, indexPoule)=>{
                    itemPoule.sort((j1,j2)=>{
                        return j2.win - j1.win || j2.goalAverage - j1.goalAverage;
                    })
                     var nbQualifie = this.tournoi.options.championnat.nbQualifie;
                   
                    this.detectPouleBalotage(itemPoule, 0, 0, nbQualifie, "qualified")
                })
                var nbPoolWhereIsInBalotage = 0;
                var nbPoolQualifed = 0;
                poule.forEach(itemPoule=>{
                    itemPoule.forEach(dataJoueur=>{
                        if (dataJoueur.balotage)
                            nbPoolWhereIsInBalotage ++;
                        else if (dataJoueur.qualifie)
                            nbPoolQualifed++;
                    })
                })
                var nbQualifedForElimi = poule.length * nbQualifie + nbQualifieComplete;
                this.goodNbEquipes = nbQualifedForElimi;
                var nbRepechage = nbQualifedForElimi - (nbPoolQualifed + nbPoolWhereIsInBalotage)
                if (nbRepechage >= 0) {
                    poule.forEach(itemPoule=>{
                        itemPoule.forEach(dataJoueur=>{
                            if (dataJoueur.balotage)
                                dataJoueur.qualifie = true;
                            dataJoueur.balotage = false;
                        })
                    })
                }
                var pouleComplete = []; 
                if (nbRepechage>0) {
                    poule.forEach(itemPoule=>{
                        itemPoule.forEach(dataJoueur=>{
                            if (!dataJoueur.qualifie && !dataJoueur.balotage) {
                                pouleComplete.push(dataJoueur);
                            }
                        })
                    })
                    pouleComplete.sort((j1,j2)=>{
                            return j2.win - j1.win || j2.goalAverage - j1.goalAverage;
                    })
                   
                    this.detectPouleBalotage(pouleComplete, 0, 0, nbRepechage, "repechage");
                }
                var repechageByPoule = [];
                var indexRepechageByPoule = -1;
                if (nbRepechage<0) {
                    //Cela signigie ici qu'on a trop de joueurs par poules
                    // On ne repeche pas les 3èmes mais par poule
                    // si il y a plus de poules en égalité que de nombre à qualifier on est dans la merde
                   
                   var raiseQualifiedTotal = 0;
                    var nbEquipeRepeche = nbQualifedForElimi - nbPoolQualifed;
                  
                    poule.forEach((itemPoule, indexPoule)=>{

                        if (itemPoule.findIndex(elt=>elt.balotage == true) != -1) {
                                var json = {
                                    qualified: 0,
                                    numeroPoule: indexPoule,
                                    data: [],
                                    raiseQualified: 0
                                }
                                indexRepechageByPoule++;
                                repechageByPoule[indexRepechageByPoule] = json;
                        
                                itemPoule.forEach(dataJoueur=>{
                                    if (dataJoueur.balotage) {
                                        repechageByPoule[indexRepechageByPoule].data.push(dataJoueur);
                                    }
                                    else if (dataJoueur.qualifie) {
                                        repechageByPoule[indexRepechageByPoule].qualified++;
                                    }
                                })
                                repechageByPoule[indexRepechageByPoule].raiseQualified  = nbQualifieComplete -  repechageByPoule[indexRepechageByPoule].qualified
                                raiseQualifiedTotal+=repechageByPoule[indexRepechageByPoule].raiseQualified;
                                /*if (repechageByPoule[indexRepechageByPoule].data.length==3 && 
                                    repechageByPoule[indexRepechageByPoule].qualified==0) {
                                        itemPoule.forEach(dataJoueur=>{
                                            dataJoueur.qualifie=true;
                                            dataJoueur.balotage=false;
                                            dataJoueur.complete=false;
                                            
                                        })
                                    repechageByPoule.splice(indexRepechageByPoule, 1);
                                    nbEquipeRepeche-=3;
                                    console.log(indexPoule+"="+nbEquipeRepeche); 
                                }*/
                        }

                    })
                    
                    
                    repechageByPoule.forEach(jsonRepeche=>{
                        jsonRepeche.data.forEach(dataJoueur=>{
                            pouleComplete.push(dataJoueur);
                        })
                    })
                }
                this.nbEquipeQualifedCompleted();
                this.pouleComplete = pouleComplete;
                
                this.poule = poule;
            },
            initNbEquipes() {
                
                if (this.equipes!=null) {
                    var nbEquipes = this.equipes.length;
                    this.nbEquipes = nbEquipes;
                
                    var optionChampionnat = {
                        nbJoueursParPool: 4,
                        nbMinJoueursParPool: 3,
                        nbJoueurs: this.nbEquipes,
                        nbTourPool: 1
                    }
                    var tirage = new Championnat(optionChampionnat);
                    this.nbEquipeSup =  tirage.findNbEquipeIdeal(nbEquipes);
                    this.goodNbEquipes = nbEquipes - this.nbEquipeSup;
                }
            },
            ciblePhase(nb) {
            if (nb!=null) {
                switch (nb) {
                     case 2 : 
                        return "la finale";
                        break;
                    case 4 : 
                        return "la demi finale";
                        break;
                    case 8 : 
                        return "les quarts de final";
                        break;
                    case 16 : 
                        return "les 8ème de final";
                        break;
                    case 32 : 
                        return "les 16ème de final";
                        break;
                    case 64 : 
                        return "les 32ème de final";
                        break;
                    case 128 : 
                        return "les 64ème de final";
                        break;
                    case 256 :
                        return "les 128ème de final";
                        break;
                    case 512 :
                        return "les 512ème de final";
                        break;
                }
            }
            return "";
        }
   } 
   
}
</script>